import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import SignalChannel from "@/components/signals/SignalChannel";

// Standalone IB Topics module. Opens the broadcast + composer directly using the
// existing idempotent shared resolver (GET /ib/signals/broadcast). No My Activity
// landing, no topic picker, no Create/Open steps. Empty broadcast is publishable.
export default function IBTopics() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [signal, setSignal] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/ib/signals/broadcast")
      .then((r) => { if (!cancelled) setSignal(r.data); })
      .catch((e) => { if (!cancelled) toast.error(e.response?.data?.detail || "Unable to open broadcast"); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const close = () => navigate("/ib");

  return (
    <div className="min-h-[60vh]" data-testid="ib-topics-page">
      {loading ? (
        <div className="flex items-center justify-center py-24" data-testid="ib-topics-loading">
          <Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" />
        </div>
      ) : signal ? (
        <SignalChannel signal={signal} mode="ib" onClose={close} onChanged={() => {}} />
      ) : (
        <div className="max-w-md mx-auto text-center card-lux p-10 mt-10" data-testid="ib-topics-error">
          <p className="text-sm text-[#64748B]">Unable to open the broadcast. Please try again.</p>
          <button onClick={close} className="mt-6 text-sm text-[#D4AF37]" data-testid="ib-topics-error-back">Back</button>
        </div>
      )}
    </div>
  );
}
